module.exports = __webpack_public_path__ + "img/wp-screenshot@2x.0c86d4bc.jpg";